import { ValueNode } from './ValueNode';
export class ParameterNode extends ValueNode {
    value;
    key;
    constructor(id, value, key, metadata) {
        super(id, key, metadata);
        this.key = key;
        this.value = value;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUGFyYW1ldGVyTm9kZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9saWIvdHlwZXMvcmVjb3JkL1BhcmFtZXRlck5vZGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTUEsT0FBTyxFQUFFLFNBQVMsRUFBRSxNQUFNLGFBQWEsQ0FBQTtBQUt2QyxNQUFNLE9BQU8sYUFFWCxTQUFRLFNBQVM7SUFDRCxLQUFLLENBQUc7SUFDUixHQUFHLENBQVE7SUFFM0IsWUFBWSxFQUFVLEVBQUUsS0FBUSxFQUFFLEdBQVcsRUFBRSxRQUFtQjtRQUNoRSxLQUFLLENBQUMsRUFBRSxFQUFFLEdBQUcsRUFBRSxRQUFRLENBQUMsQ0FBQTtRQUN4QixJQUFJLENBQUMsR0FBRyxHQUFHLEdBQUcsQ0FBQTtRQUNkLElBQUksQ0FBQyxLQUFLLEdBQUcsS0FBSyxDQUFBO0lBQ3BCLENBQUM7Q0FDRiJ9